var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-navbar",
        { attrs: { fixed: "top", type: "light", variant: "faded" } },
        [
          _c("div", { staticClass: "navbar-left" }, [_vm._t("navbar-left")], 2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "navbar-center" },
            [
              _c(
                "b-navbar-brand",
                _vm._b(
                  { staticClass: "navbar-brand mx-auto" },
                  "b-navbar-brand",
                  _vm.navbarBrandProps,
                  false
                ),
                [
                  _c("b-img", {
                    attrs: {
                      alt: "CSP Logo",
                      height: "160",
                      src: _vm.logoImage,
                      width: "43",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "navbar-right" }, [
            _c(
              "ul",
              { staticClass: "navbar-nav navbar-expand justify-content-end" },
              [
                _c(
                  "li",
                  { staticClass: "nav-item d-flex align-items-center mr-1" },
                  [_c("csp-global-loading-indicator")],
                  1
                ),
                _vm._v(" "),
                _vm._t("navbarRightItems"),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("csp-new-version-warning"),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "container-main", attrs: { fluid: "xl" } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.shouldShowImprintLinks
        ? _c("div", { staticClass: "imprint-wrapper" }, [
            _c(
              "a",
              {
                attrs: {
                  href: "https://autoclaim.de/impressum/",
                  rel: "noopener noreferrer",
                  target: "_blank",
                },
              },
              [_vm._v("Impressum")]
            ),
            _vm._v(" "),
            _c("span", [_vm._v("•")]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://autoclaim.de/datenschutz/",
                  rel: "noopener noreferrer",
                  target: "_blank",
                },
              },
              [_vm._v("Datenschutz")]
            ),
            _vm._v(" "),
            _c("span", [_vm._v("•")]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "/de/Schaden-Manager/",
                  rel: "noopener noreferrer",
                },
              },
              [_vm._v("Desktop")]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }